import React, { useState } from "react";
import { useParams } from "react-router";
import { Heading, Loader, Popup } from "uikit/components";
import { BackLink } from "components";
import styles from "./SchoolTrainingPlansPage.module.styl";
import Pagination from "uikit/components/Pagination/Pagination";
import math from "lodash";
import { useSchoolTrainingPlans } from "hooks/trainingPlans";
import SchoolTrainingPlansView from "components/schoolTrainingPlans/SchoolTrainingPlansView/SchoolTrainingPlansView";
import { useContextPerson } from "hooks/persons";
import { Flags } from "utils";
import { Helmet } from "react-helmet-async";

export default function SchoolTrainingPlansPage() {
    const pageSize = 20;

    const [payload, setPayload] = useState({ pageNumber: 1 });

    const { schoolId, municipalityId, regionId } = useParams();
    const { flags, isLoading: isContextLoading } = useContextPerson();
    const { isLoading, data } = useSchoolTrainingPlans(schoolId, payload, {
        keepPreviousData: true,
    });

    const handlePageChange = (newPageNumber) => {
        setPayload((payload) => ({ ...payload, pageNumber: newPageNumber }));
    };

    if (isLoading || isContextLoading) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text" />
            </Popup>
        );
    }

    if (data) {
        return (
            <>
                <Helmet>
                    <meta
                        name="apple-mobile-web-app-title"
                        content={`Ведение планов тренировок: ${data.schoolName}`}
                    />
                    <meta
                        name="application-name"
                        content={`Ведение планов тренировок: ${data.schoolName}`}
                    />
                </Helmet>
                {!flags?.[Flags.HideDashboardBackButton] && (
                    <BackLink
                        to={
                            regionId
                                ? `/training-plans/region/${regionId}`
                                : municipalityId
                                ? `/training-plans/municipality/${municipalityId}`
                                : `/school-summary/${schoolId}`
                        }
                        text={"Назад"}
                        name={"back-school-training-plans"}
                    />
                )}
                <Heading size={"h1"} className={styles.heading} name="school-training-plans-header">
                    Ведение планов тренировок: {data.schoolName}
                </Heading>
                <SchoolTrainingPlansView groupsTrainingPlans={data.groupsTrainingPlans} />
                {data.count > pageSize && (
                    <Pagination
                        pageCount={math.ceil(data.count / pageSize)}
                        forcePage={payload.pageNumber}
                        onPageChange={handlePageChange}
                        className={styles.pagination}
                    />
                )}
            </>
        );
    }
}
